export enum RatingType {
    Profile = 'profile',
    Event = 'event'
}
